import PrentMyUHLInvoice from '../containers/PrentMyUHLInvoice'

const PrentMyUHLInvoicePage = () => {
    return <PrentMyUHLInvoice/>
}
export default PrentMyUHLInvoicePage